import { render, staticRenderFns } from "./StatusUpdateConfirmation.vue?vue&type=template&id=936bab1a"
import script from "./StatusUpdateConfirmation.vue?vue&type=script&lang=js"
export * from "./StatusUpdateConfirmation.vue?vue&type=script&lang=js"
import style0 from "./StatusUpdateConfirmation.vue?vue&type=style&index=0&id=936bab1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports